import type { MemoBlock } from '@/shared/templates/memos'
import type { MemoItem } from '@/shared/templates/memos/lib/renderMemo'
import { copiesForBlocks } from './blockCopies'

/**
 * The items one picked candidate adds to the memo: one per active block where
 * the template puts its material in all of them, and otherwise the candidate
 * itself, in the block it belongs in.
 *
 * A candidate column maps its items into the template's `defaultBlockId`, which
 * the editor may since have removed. With one block left there is no choice to
 * ask about, so the candidate resolves into that one - the same answer a block
 * collapse gives the items still waiting on the batch bar. Left as it was
 * mapped, it would render under a block the preview no longer shows, which in
 * template order means above the block that is left.
 *
 * With more than one block left the mapped block is kept: such an item waits on
 * the batch bar for the editor's own answer, and is rebadged when it comes.
 */
export function additionsFor(
  item: MemoItem,
  activeBlocks: MemoBlock[],
  insertsIntoEveryBlock: boolean
): MemoItem[] {
  if (insertsIntoEveryBlock) {
    return copiesForBlocks(item, activeBlocks)
  }

  const soleBlock = activeBlocks.length === 1 ? activeBlocks[0] : undefined

  if (soleBlock && soleBlock.id !== item.blockId) {
    return [{ ...item, blockId: soleBlock.id }]
  }

  return [item]
}
